import { IData } from '../fetchTemplates'
import { ITemplate } from '../index'

export default function(response: IData) {
  return response.items.map(
    (item): ITemplate => ({
      content: item.content
        .split('<b>')
        .join('')
        .split('</b>')
        .join('')
        .split('\r\n')
        .join(''),
      createdAt: new Date(Number(item.created_at) * 1000),
      id: Number(item.id),
      idStatus: Number(item.id_status),
      idType: Number(item.id_type),
      idUser: Number(item.id_user),
      language: String(item.language),
      position: String(item.position),
      title: String(item.title),
      typeTitle: String(item.type_title),
      updatedAt: new Date(Number(item.updated_at) * 1000),
    }),
  )
}
